import { Check } from 'react-feather'

import { CircularProgress } from '@mui/material'
import { MUI } from 'components'

import { theme } from 'theme'

import { FeedbackItemType } from './feedbackItem.types'

const FeedbackItem = ({ step, concluded }: FeedbackItemType) => {
  return (
    <MUI.Grid item lg={7} md={8} xs={12}>
      <MUI.Box display="flex" alignItems="center" gap={4}>
        <MUI.Box display="inline-flex" position="relative">
          <CircularProgress
            thickness={3}
            variant={concluded ? 'determinate' : 'indeterminate'}
            value={100}
          />
          {concluded && (
            <MUI.Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Check size={30} color={theme.palette.primary.main} />
            </MUI.Box>
          )}
        </MUI.Box>
        <MUI.Typography variant="h6">{step}</MUI.Typography>
      </MUI.Box>
    </MUI.Grid>
  )
}

export default FeedbackItem
